import {createApp} from 'vue'
import App from './views/App.vue';
import Login from './views/Login.vue';
import store from './store';
import router from './router';
import api from './api';
import heyui, {confirm, loading, message} from "heyui.ext";
import AppContent from './components/AppContent';
import AccountDateChoose from './components/AccountDateChoose';
import SubMenu from './components/common/sub-menu';
import RouterLink from './components/RouterLink';
import Chart from './views/app/chart/echarts';
import {useTable} from '@js/common/xe-table';
import filters from './js/common/filters';
import '@layui/layer-vue/lib/index.css';
import layer from '@layui/layer-vue';
import print from 'vue3-print-nb'//jxd 打印插件

import htmlToExcel from './utils/htmlToExcel';//刚刚写好的那个js文件的路径jxddd


import './js/config/dict';
import 'windi.css'
import 'font-awesome/css/font-awesome.css'
import './styles/app.less';

let app;
store.dispatch("init").then(() => {
	app = createApp(App);
	app.use(print);//注册打印插件jxd
	app.config.globalProperties.$api = api;
	app.config.globalProperties.$Message = message;
	app.config.globalProperties.$Message.config({
        timeout: 6000 // 设置关闭时间为 8 秒
    });
	app.config.globalProperties.$Loading = loading;
	// 将 htmlToExcel 挂载到应用实例的全局属性上jxddd
	app.config.globalProperties.htmlToExcel = htmlToExcel;

	app.config.globalProperties.$Confirm = (content) => {
		return new Promise((resolve, reject) => {
			confirm({
				title: "操作提示",
				content,
				onConfirm: resolve,
				onCancel: reject
			})
		})
	};

	app.use(useTable).use(layer).use(filters).use(router).use(heyui).use(store);
	app.component("app-content", AppContent);
	app.component("account-date-choose", AccountDateChoose);
	app.component('sub-menu', SubMenu);
	app.component('Chart', Chart);
	app.component('RouterLink', RouterLink);

}).catch((err) => {
	app = createApp(Login).use(store).use(heyui).use(filters);
	app.config.globalProperties.$api = api;
	app.config.globalProperties.$Message = message;
	app.config.globalProperties.$Message.config({
        timeout: 6000 // 设置关闭时间为 8 秒
    });
}).finally(() => {
	app.config.globalProperties.APP_NAME = process.env.VUE_APP_NAME;
	app.config.globalProperties.BUID_DATE = process.env.VUE_APP_BUID_DATE;
	app.config.globalProperties.VERSION ="1.0.0.1";//process.env.VUE_APP_VERSION;
	app.mount('#app')
});
